export const cLogMoodle = {
    CATEGORIA: 1,
    CURSO: 2,
    ESTUDIANTE: 3,
    PROFESOR: 4,
    USUARIO: 5
}
